const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const USERS_API_URL = `${API_BASE_URL}/api/users`;

const persistAuth = (responseData) => {
  localStorage.setItem('token', responseData.token);
  localStorage.setItem('user', JSON.stringify(responseData.user));
  return responseData;
};

export const signupUser = async (userData) => {
  try {
    const response = await fetch(`${USERS_API_URL}/signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Signup failed');
    }

    return await response.json();
  } catch (error) {
    console.error("Signup Error:", error);
    throw error;
  }
};

export const loginUser = async (loginData) => {
  try {
    const response = await fetch(`${USERS_API_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Login failed');
    }

    const responseData = await response.json();
    return persistAuth(responseData);
  } catch (error) {
    console.error("Login Error:", error);
    throw error;
  }
};

export const loginWithGoogle = async (credential) => {
  try {
    const response = await fetch(`${USERS_API_URL}/google`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ credential }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Google sign-in failed');
    }

    const responseData = await response.json();
    return persistAuth(responseData);
  } catch (error) {
    console.error("Google Login Error:", error);
    throw error;
  }
};

export const fetchUserProfile = async (username) => {
  try {
    const response = await fetch(`${USERS_API_URL}/user/${username}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch user profile');
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch User Profile Error:", error);
    throw error;
  }
};

export const updateProfile = async (profileData) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }

    const response = await fetch(`${USERS_API_URL}/profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(profileData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Profile update failed');
    }

    return await response.json();
  } catch (error) {
    console.error("Profile Update Error:", error);
    throw error;
  }
};

export const uploadProfileImage = async (file) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No token found');
  }

  const signatureResponse = await fetch(`${USERS_API_URL}/profile/image-signature`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!signatureResponse.ok) {
    const errorData = await signatureResponse.json();
    throw new Error(errorData.message || 'Failed to start image upload');
  }

  const { cloudName, apiKey, signature, timestamp, folder } = await signatureResponse.json();
  const formData = new FormData();
  formData.append('file', file);
  formData.append('api_key', apiKey);
  formData.append('timestamp', timestamp);
  formData.append('signature', signature);
  formData.append('folder', folder);

  const uploadResponse = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
    method: 'POST',
    body: formData,
  });

  const uploadData = await uploadResponse.json();
  if (!uploadResponse.ok) {
    throw new Error(uploadData.error?.message || 'Image upload failed');
  }

  return uploadData;
};
